import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — El Bloqueo Invisible',
  subtitle: 'Dejá de quedarte callado sin saber por qué',
  accent: 'border-l-blue-500',
  items: ['Identificación de miedos internos', 'Por qué evitamos el conflicto', 'El costo del silencio', 'Primeros pasos para soltar', 'Autoconocimiento emocional', 'Superación del bloqueo inicial']
}, {
  icon: '🟣',
  title: 'Tomo 2 — El lenguaje que abre y el que cierra',
  subtitle: 'Aprendé a hablar sin generar rechazo',
  accent: 'border-l-purple-500',
  items: ['Palabras que disparan defensas', 'Comunicación no violenta', 'El tono de voz adecuado', 'Escucha activa real', 'Validación emocional', 'Cómo pedir sin exigir']
}, {
  icon: '🔴',
  title: 'Tomo 3 — Conversaciones difíciles',
  subtitle: 'Enfrentá lo que venís evitando',
  accent: 'border-l-red-500',
  items: ['Preparación para el diálogo', 'Manejo de la tensión', 'Guiones para temas tabú', 'Cómo no perder el eje', 'Cierre de conversaciones', 'Seguimiento post-charla']
}, {
  icon: '🟠',
  title: 'Tomo 4 — Cuando tus padres no quieren escuchar',
  subtitle: 'Qué hacer cuando hay resistencia',
  accent: 'border-l-orange-500',
  items: ['Entender su perspectiva', 'Manejo de la terquedad', 'Límites saludables', 'Cuándo insistir y cuándo parar', 'Estrategias de paciencia', 'Cambio de enfoque']
}, {
  icon: '🟢',
  title: 'Tomo 5 — Conversaciones que generan cambio real',
  subtitle: 'Lográ impacto real',
  accent: 'border-l-green-500',
  items: ['Acuerdos de convivencia', 'Transformación de vínculos', 'Perdón y reconciliación', 'Nuevas dinámicas familiares', 'Sostenibilidad del cambio', 'Resultados tangibles']
}, {
  icon: '🟡',
  title: 'Tomo 6 — El sistema de comunicación familiar',
  subtitle: 'Sostené el cambio en el tiempo',
  accent: 'border-l-yellow-400',
  items: ['Rutinas de comunicación', 'Prevención de recaídas', 'Mantenimiento del vínculo', 'Crecimiento conjunto', 'Legado familiar', 'Paz mental duradera']
}];
const features = ['Guiones listos para usar', 'Estrategias prácticas', 'Ejemplos reales', 'Aplicación inmediata', 'Lenguaje claro'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-296">
      <div className="max-w-xl mx-auto" data-id="element-297">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-298">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-299">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-300">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-301">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-302">
                  <span className="text-2xl flex-shrink-0" data-id="element-303">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-304">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-305">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-306">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-307" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-308" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-309">
                    <div className="space-y-2" data-id="element-310">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-311">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-312" />
                          <span className="text-xs text-gray-400" data-id="element-313">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-314">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-315">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-316">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-317">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-318" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-319">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}